import { render, staticRenderFns } from "./PeriodShiftIncNew.vue?vue&type=template&id=24be9104"
import script from "./PeriodShiftIncNew.vue?vue&type=script&lang=js"
export * from "./PeriodShiftIncNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports